import React from 'react'
import { Link } from 'react-router-dom'

const BrudCrumb = ({ title }) => {
    return (
        <div className='dash_bredcrumb'>
            <h2>{title}</h2>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link href="#">Home</Link></li>
                    <li className="breadcrumb-item"><Link href="#">Library</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Data</li>
                </ol>
            </nav>
        </div>
    )
}

export default BrudCrumb
